import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju3qnrunvu: FaireProductEntity = {
  token: "p_ju3qnrunvu",
  type: "product",
  name: "evergreen gift wrapping paper",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/8013087c818e735936df9f0320ac8132e0647ae41569eefcaf18893a8c4917fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8271b397c3c92d7a09723aeb894e1e690d4baad5b3ca0bf3fd38c895c9ea8af5.jpeg",
    "https://cdn.faire.com/fastly/215865cf58c8a5f3f6612f4e13a8f015bb2af61b65dbb603b17d7d7b00cd530f.jpeg",
    "https://cdn.faire.com/fastly/96c511e0c8199f738696392e2928c48df28ef69b0d377709ed1a057e767a8135.jpeg",
  ],
  priceDollars: 6,
  description:
    'Make your Christmas gifts extra lovely with decorative wrapping paper.\nPrinted on matte paper that’s just the right weight for crisp folds and smooth creases, each set includes three pre-cut sheets for easy wrapping. Perfect for adding a beautiful finishing touch to any present.\n\n• Three rolled sheets\n• 19 ¾" x 28"\n• 80lb matte paper',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:45.585Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
